var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9613 13.8799H41.4229C41.9941 13.8799 42.5419 14.1068 42.9459 14.5107C43.3498 14.9147 43.5767 15.4625 43.5767 16.0337V46.1876C43.5767 46.7588 43.3498 47.3067 42.9459 47.7106C42.5419 48.1145 41.9941 48.3414 41.4229 48.3414H15.5767C15.0055 48.3414 14.4576 48.1145 14.0537 47.7106C13.6498 47.3067 13.4229 46.7588 13.4229 46.1876V16.0337C13.4229 15.4625 13.6498 14.9147 14.0537 14.5107C14.4576 14.1068 15.0055 13.8799 15.5767 13.8799H22.0382",
    stroke: "#30537E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9617 18.1877H22.0386V11.7261C22.0386 11.1549 22.2655 10.607 22.6694 10.2031C23.0733 9.79919 23.6212 9.57227 24.1924 9.57227H32.8078C33.379 9.57227 33.9269 9.79919 34.3308 10.2031C34.7347 10.607 34.9617 11.1549 34.9617 11.7261V18.1877Z",
    stroke: "#30537E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0386 35.4181H34.9617M22.0386 26.8027H34.9617",
    stroke: "#30537E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTask);
export default __webpack_public_path__ + "static/media/add_task.0a23532129d29d2a09121debe1a8caaa.svg";
export { ForwardRef as ReactComponent };